import { atom } from 'recoil';
import { QueueModel } from '../types/models/queue-model';

export const queuesState = atom<QueueModel[]>({
  key: 'Queues',
  default: []
});
